import { useContext } from "react";

// context
import context from "../../store/context";

// icons
import SearchIcon from "../icons/Search";

const FloatingSearch = () => {
  const { showDrawerHandler } = useContext(context);

  return (
    <button
      onClick={showDrawerHandler}
      aria-label="Search"
      className="md:hidden fixed right-5 bottom-[106px] z-50 w-12 h-12 flex items-center justify-center rounded-full
      bg-white/60 backdrop-blur-xl backdrop-saturate-150 border border-white/60 ring-1 ring-black/5
      text-[#664bc7] shadow-[0_2px_8px_rgba(0,0,0,0.08)] active:scale-95 transition-transform"
    >
      <SearchIcon styles="w-6 h-6" />
    </button>
  );
};

export default FloatingSearch;
